<template>
  <div v-bind:id="uniqueId">
    <div v-show="showLoading">
      <div id="loading-grid">
        <svg
          class="spinner"
          width="65px"
          height="65px"
          viewBox="0 0 66 66"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle
            class="path"
            fill="none"
            stroke-width="6"
            stroke-linecap="round"
            cx="33"
            cy="33"
            r="30"
          ></circle>
        </svg>
      </div>
    </div>
    <div :class="tableContainerClasses" v-show="!showLoading">
      <div class="flex mb-2">
        <div class="vx-col lg:w-1/3 w-full">
          <label class="vs-select--label">نام دسترسی </label>
          <vs-input
            name="user"
            v-model="permissionName"
            @keyup.enter="searchPermission(permissionName)"
          />
        </div>
        <div class="vx-col lg:w-1/6 w-full">
          <vs-button
            class="mt-6 p-2 mx-3"
            color="success"
            type="gradient"
            icon-pack="feather"
            icon="icon-search"
            @click.prevent="searchPermission(permissionName)"
          ></vs-button>
        </div>
        <div class="vx-col lg:w-1/2 w-full">
          <vs-button
            color="success"
            type="gradient"
            icon-pack="feather"
            size="large"
            class="mx-2 mt-4 float-right"
            @click.prevent="submitForm()"
            >{{ $t("Submit") }}</vs-button
          >
        </div>
      </div>
      <div class="con-tablex vs-table--content">
        <div class="vs-con-tbody vs-table--tbody">
          <table class="vs-table vs-table--tbody-table">
            <thead class="vs-table--thead">
              <template style="display: flex">
                <tr>
                  <th style="text-align: center">عنوان فارسی</th>
                  <th style="text-align: center">عنوان انگلیسی</th>
                </tr>
              </template>
            </thead>
            <tbody class="list" v-for="i in rowItems" :key="i.id" ref="total">
              <template>
                <tr
                  :class="i.__tableRowClass"
                  style="background-color: white;border-bottom: 1px solid #ddd;"
                >
                  <td style="text-align: right;padding:1% 0;display: flex">
                    <template v-if="i.children.length">
                      <feather-icon
                        v-if="i.hasChildren"
                        @click="onShowChildren(i)"
                        icon="ChevronDownIcon"
                        style="width:1rem; height:1rem"
                        class="cursor-pointer m-2"
                      ></feather-icon>
                      <feather-icon
                        v-else
                        @click="onShowChildren(i)"
                        icon="ChevronLeftIcon"
                        style="width:1rem; height:1rem"
                        class="cursor-pointer m-2"
                      ></feather-icon>
                    </template>
                    <div v-else style="width: 2rem;"></div>
                    <input
                      type="checkbox"
                      :id="i.permissionId"
                      aria-checked="mixed"
                      style="width: 2rem;height: 2rem;"
                      @click="changeValueSelectStateAndCheckbox(i)"
                      :value="i.selectState"
                    />
                    <label
                      :id="i.name"
                      :for="i.permissionId"
                      class="mx-3 mt-1"
                      style="font-size: 1rem"
                      >{{ i.persianName }}</label
                    >
                  </td>
                  <td>{{ i.name }}</td>
                </tr>
                <template v-for="firstChild in i.children">
                  <tr
                    v-show="i.hasChildren"
                    v-if="i.children"
                    :key="firstChild.id"
                    :class="i.__tableRowClass"
                    style="
                        background-color: rgba(200, 200, 200, 0.3) !important;"
                  >
                    <td
                      style="text-align: right; padding:0.8% 7%;display: flex;"
                    >
                      <template v-if="firstChild.children.length">
                        <feather-icon
                          v-if="firstChild.hasChildren"
                          @click="onShowChildren(firstChild)"
                          icon="ChevronDownIcon"
                          style="width:1rem; height:1rem"
                          class="cursor-pointer m-2"
                        ></feather-icon>
                        <feather-icon
                          v-else
                          @click="onShowChildren(firstChild)"
                          icon="ChevronLeftIcon"
                          style="width:1rem; height:1rem"
                          class="cursor-pointer m-2"
                        ></feather-icon>
                      </template>
                      <div v-else style="width: 2rem;"></div>
                      <input
                        type="checkbox"
                        :id="firstChild.permissionId"
                        aria-checked="mixed"
                        style="width: 1.75rem;height: 1.75rem;"
                        @click="changeValueSelectStateAndCheckbox(firstChild)"
                        :value="firstChild.selectState"
                      />
                      <label
                        :id="firstChild.name"
                        :for="firstChild.permissionId"
                        class="mx-3 mt-1"
                        style="font-size: 1rem;"
                      >
                        {{ firstChild.persianName }}
                      </label>
                    </td>
                    <td>{{ firstChild.name }}</td>
                  </tr>
                  <template v-for="secondChild in firstChild.children">
                    <tr
                      v-show="firstChild.hasChildren"
                      v-if="firstChild.children"
                      :key="secondChild.id"
                      style="background-color:rgba(200, 200, 200, 0.7) !important;"
                      :class="i.__tableRowClass"
                    >
                      <td
                        style="padding:0.6% 14%;text-align: right;display: flex"
                      >
                        <template v-if="secondChild.children.length">
                          <feather-icon
                            v-if="secondChild.hasChildren"
                            @click="onShowChildren(secondChild)"
                            icon="ChevronDownIcon"
                            style="width:1rem; height:1rem"
                            class="cursor-pointer m-2"
                          ></feather-icon>
                          <feather-icon
                            v-else
                            @click="onShowChildren(secondChild)"
                            icon="ChevronLeftIcon"
                            style="width:1rem; height:1rem"
                            class="cursor-pointer m-2"
                          ></feather-icon>
                        </template>

                        <div v-else style="width: 2rem;"></div>
                        <input
                          type="checkbox"
                          :id="secondChild.permissionId"
                          aria-checked="mixed"
                          style="width: 1.55rem;height: 1.55rem;"
                          @click="
                            changeValueSelectStateAndCheckbox(secondChild)
                          "
                          :value="secondChild.selectState"
                        />
                        <label
                          :id="secondChild.name"
                          :for="secondChild.permissionId"
                          class="mx-3 mt-1"
                          style="font-size: 1rem;"
                        >
                          {{ secondChild.persianName }}
                        </label>
                      </td>
                      <td>{{ secondChild.name }}</td>
                    </tr>
                    <template v-for="thirdChild in secondChild.children">
                      <tr
                        v-show="secondChild.hasChildren"
                        v-if="secondChild.children"
                        :key="thirdChild.id"
                        style="background-color:  rgba(200, 200, 200, 1) !important;"
                        :class="i.__tableRowClass"
                      >
                        <td
                          style="padding:0.4% 21%; text-align: right;display: flex"
                        >
                          <template v-if="thirdChild.children.length">
                            <feather-icon
                              v-if="thirdChild.hasChildren"
                              @click="onShowChildren(thirdChild)"
                              icon="ChevronDownIcon"
                              style="width:1rem; height:1rem"
                              class="cursor-pointer "
                            ></feather-icon>
                            <feather-icon
                              v-else
                              @click="onShowChildren(thirdChild)"
                              icon="ChevronLeftIcon"
                              style="width:1rem; height:1rem"
                              class="cursor-pointer "
                            ></feather-icon>
                          </template>
                          <div v-else style="width: 2rem;"></div>
                          <input
                            type="checkbox"
                            :id="thirdChild.permissionId"
                            aria-checked="mixed"
                            style="width: 1.25rem;height: 1.25rem;"
                            @click="
                              changeValueSelectStateAndCheckbox(thirdChild)
                            "
                            :value="thirdChild.selectState"
                          />
                          <label
                            :id="thirdChild.name"
                            :for="thirdChild.permissionId"
                            class="mx-3 mt-1"
                            style="font-size: 1rem;"
                          >
                            {{ thirdChild.persianName }}
                          </label>
                        </td>
                        <td>{{ thirdChild.name }}</td>
                      </tr>
                    </template>
                  </template>
                </template>
              </template>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="scss">
#div-loading .con-vs-loading {
  position: unset !important;
  margin: 0 auto;
  display: initial;
}

#div-loading .con-vs-loading .vs-loading {
  margin: 0 auto;
  display: inline-flex;
  width: 100%;
}
.textInSearch {
  color: #007470;
  font-weight: bold;
}
</style>
<script>
import { ajax } from "@/plugins/ajax";
import utils from "@/assets/utils/index";
import "../../assets/scss/vuesax-rtl/_grid-style.scss";

export default {
  name: "tree-grid-select",
  props: {
    columns: {
      type: Array,
      default: () => []
    },

    dataSource: {
      type: Object,
      default: () => ({
        type: "",
        url: "",
        method: "get",
        service: "",
        transform: null,
        data: null
      })
    },

    striped: {
      type: Boolean,
      default: true
    },
    bordered: {
      type: Boolean,
      default: true
    },
    hover: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    tableContainerClasses() {
      var classes = "datagrid vs-component vs-con-table vs-table-primary";
      if (this.striped === true) classes += " stripe";
      if (this.bordered === true) classes += " table-bordered";
      if (this.hover === true) classes += " table-hover";
      return classes;
    }
  },
  updated() {
    this.mylist = [];
    this.setCheckboxWithSelectState();
    if (this.firstShow < 2) {
      this.falseHasChildrenForSearch(this.rowItems);
      this.firstShow++;
    }
  },

  data() {
    var uniqueId = "dt_" + utils.randomString(8);
    return {
      firstShow: 0,
      uniqueId: uniqueId,
      rowItems: [],
      showLoading: false,
      errorOccurred: false,
      permissionName: "",
      itWasInSearch: false,
      check: 0,
      halfCheck: 0,
      mylist: []
    };
  },
  mounted() {
    this.renderGrid();
  },
  methods: {
    searchPermission(i) {
      this.itWasInSearch = false;
      this.falseHasChildrenForSearch(this.rowItems);
      for (let index = 0; index < this.rowItems.length; index++) {
        if (this.rowItems[index].children.length) {
          let currentFirstParent = this.rowItems[index];
          for (
            let index1 = 0;
            index1 < currentFirstParent.children.length;
            index1++
          ) {
            if (
              currentFirstParent.children[index1].persianName.includes(i) ||
              currentFirstParent.children[index1].name.includes(i)
            ) {
              currentFirstParent.hasChildren = true;
              this.itWasInSearch = true;
              let element = document.getElementById(
                currentFirstParent.children[index1].name
              );
              element.classList.add("textInSearch");
            }
            if (currentFirstParent.children[index1].children.length) {
              let currentSecondParent = currentFirstParent.children[index1];
              for (
                let index2 = 0;
                index2 < currentSecondParent.children.length;
                index2++
              ) {
                if (
                  currentSecondParent.children[index2].persianName.includes(
                    i
                  ) ||
                  currentSecondParent.children[index2].name.includes(i)
                ) {
                  currentFirstParent.hasChildren = true;
                  currentSecondParent.hasChildren = true;
                  this.itWasInSearch = true;
                  let element = document.getElementById(
                    currentSecondParent.children[index2].name
                  );
                  element.classList.add("textInSearch");
                }

                if (currentSecondParent.children[index2].children.length) {
                  let currentThridParent = currentSecondParent.children[index2];
                  for (
                    let index3 = 0;
                    index3 < currentThridParent.children.length;
                    index3++
                  ) {
                    if (
                      currentThridParent.children[index3].persianName.includes(
                        i
                      ) ||
                      currentThridParent.children[index3].name.includes(i)
                    ) {
                      currentFirstParent.hasChildren = true;
                      currentSecondParent.hasChildren = true;
                      currentThridParent.hasChildren = true;
                      this.itWasInSearch = true;
                      let element = document.getElementById(
                        currentThridParent.children[index3].name
                      );
                      element.classList.add("textInSearch");
                    }
                  }
                }
              }
            }
          }
        } else {
          if (this.rowItems[index].persianName.includes(i)) {
            this.itWasInSearch = true;
            let element = document.getElementById(this.rowItems[index].name);
            element.classList.add("textInSearch");
          }
        }
      }
      if (this.itWasInSearch == false) {
        this.$swal({
          position: "center-center",
          type: "warning",
          text: "چنین عبارتی پیدا نشد!",
          showConfirmButton: false,
          timer: 2000
        });
      }
    },
    falseHasChildrenForSearch(r) {
      for (let index = 0; index < r.length; index++) {
        r[index].hasChildren = false;
        let element = document.getElementById(r[index].name);
        element.classList.remove("textInSearch");
        if (r[index].children.length) {
          this.falseHasChildrenForSearch(r[index].children);
        }
      }
    },
    loopForChildren(i, v, st) {
      if (i.children) {
        for (let index = 0; index < i.children.length; index++) {
          if (v == 1) {
            i.children[index].hasChildren = false;
            this.loopForChildren(i.children[index], 1, 0);
          } else if (v == 2) {
            i.children[index].selectState = st;
            this.loopForChildren(i.children[index], 2, st);
          }
        }
      }
    },
    onShowChildren(i) {
      i.hasChildren = !i.hasChildren;
      if (!i.hasChildren) {
        this.loopForChildren(i, 1, 0);
      }
    },
    renderGrid() {
      var self = this;
      this.showLoading = true;

      this.getData()
        .then(result => {
          self.rowItems = result;
          this.showLoading = false;
        })
        .catch(() => {});
    },
    getData() {
      var self = this;
      return new Promise((resolve, reject) => {
        if (this.dataSource) {
          var getDataFromResourcePromise = self.getDataFromAppService();
          getDataFromResourcePromise
            .then(result => {
              if (
                this.dataSource.transform &&
                utils.isFunction(this.dataSource.transform)
              )
                result = this.dataSource.transform(result);
              resolve(result);
            })
            .catch(e => {
              reject(e);
            });
        } else {
          reject();
          this.errorOccurred = true;
        }
      });
    },
    getDataFromAppService() {
      var self = this;
      return new Promise((resolve, reject) => {
        ajax[self.dataSource.method || "get"](self.dataSource.service)
          .then(r => {
            if (r) {
              resolve(r.data);
            } else {
              reject();
            }
          })
          .catch(() => {
            reject();
            this.errorOccurred = true;
          });
      });
    },
    setCheckboxWithSelectState(r = this.rowItems) {
      for (let index = 0; index < r.length; index++) {
        let checkbox = document.getElementById(r[index].permissionId);
        if (r[index].children.length) {
          this.setCheckboxWithSelectState(r[index].children);
          this.resultValueSelectState = this.setCheckboxWithSelectStateDueToChildren(
            r[index].children
          );
          r[index].selectState = this.resultValueSelectState;
          this.checkvalueSelectState(checkbox, r[index]);
        } else {
          this.checkvalueSelectState(checkbox, r[index]);
        }
      }
    },
    checkvalueSelectState(Currentcheckbox, currentValueSelectState) {
      if (currentValueSelectState.selectState == 3) {
        Currentcheckbox.checked = false;
        Currentcheckbox.indeterminate = true;
      } else if (currentValueSelectState.selectState == 1) {
        Currentcheckbox.indeterminate = false;
        Currentcheckbox.checked = true;
        this.mylist.push(currentValueSelectState.permissionId);
      } else {
        Currentcheckbox.checked = false;
        Currentcheckbox.indeterminate = false;
      }
    },
    setCheckboxWithSelectStateDueToChildren(i) {
      this.check = 0;
      this.halfCheck = 0;
      for (let index = 0; index < i.length; index++) {
        if (i[index].selectState == 1) {
          this.check++;
        } else if (i[index].selectState == 3) {
          this.halfCheck++;
        }
      }
      if (this.check == i.length) {
        return 1;
      } else if (this.check > 0 || this.halfCheck > 0) {
        return 3;
      } else return 2;
    },
    changeValueSelectStateAndCheckbox(i) {
      if (i.selectState == 2 || i.selectState == 3) {
        i.selectState = 1;
        this.loopForChildren(i, 2, 1);
      } else {
        i.selectState = 2;
        this.loopForChildren(i, 2, 2);
      }
    },
    submitForm() {
      this.$emit("apiCall", this.mylist);
    }
  }
};
</script>
